<template>
  <div class="add-to-cart-modal">
    <div class="add-to-cart-modal__info">
      <div class="add-to-cart-modal__image">
        <picture v-if="productInfo.sku">
          <source media="(min-width: 768px)" :srcset="`/media/product/${productInfo.sku}?size=160`" />
          <cdr-img
            class="product__image"
            :alt="productInfo.description"
            :src="`/media/product/${productInfo.sku}?size=130`"
          />
        </picture>
      </div>
      <div class="add-to-cart-modal__content">
        <cdr-text class="add-to-cart-modal__data">
          {{ productInfo.description }}<br />
          Qty: {{ productInfo.quantity }}<br />
          Price: {{ formatToCurrency(productInfo.price) }}
        </cdr-text>
      </div>
    </div>
    <cdr-text class="add-to-cart-modal__info-bold">
      Cart subtotal: {{ formatToCurrency(cart.order.totalProduct) }}
      <span>({{ cart.order.totalItemQuantity }} items)</span>
    </cdr-text>
    <div class="add-to-cart-modal__buttons">
      <cdr-button
        href="/ShoppingCart"
        class="add-to-cart-modal__button"
        tag="a"
        target="_self"
        data-ui="go-to-cart"
        @click="handleMetric('go-to-cart')"
      >
        Cart & Checkout
      </cdr-button>
      <cdr-button
        modifier="secondary"
        class="add-to-cart-modal__button"
        data-ui="add-to-cart-modal__close"
        @click="$emit('declineTerms')"
      >
        Continue shopping
      </cdr-button>
    </div>
  </div>
</template>

<script>
import { CdrButton, CdrImg, CdrText } from '@rei/cedar';
import { mapState } from 'pinia';
import metrics from '../../utils/metrics';
import formatToCurrency from '../../common/format-currency';
import { useWishlistStore } from '../../stores';

export default {
  name: 'AddToCartModal',
  components: {
    CdrButton,
    CdrImg,
    CdrText,
  },
  mixins: [formatToCurrency],
  props: {
    productInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useWishlistStore, ['cart']),
  },
  methods: {
    handleMetric(metric) {
      metrics.metricsClick(metric);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.add-to-cart-modal {
  padding-bottom: $cdr-space-one-and-a-half-x;
  &__warning-head {
    @extend %cdr-text-body-strong-300;
    margin-bottom: $cdr-space-three-quarter-x;
  }
  &__info {
    display: flex;
    margin-bottom: $cdr-space-one-x;
  }
  &__image {
    margin-right: $cdr-space-one-x;
  }
  &__buttons {
    display: block;
    margin-top: $cdr-space-two-x;
  }
  &__button {
    display: block;
    margin-bottom: $cdr-space-two-x;
    text-align: center;
    width: 100%;
  }
  &__info {
    &-bold {
      @extend %cdr-text-body-strong-300;
      span {
        font-weight: normal;
      }
    }
  }
}
@media screen and (min-width: $cdr-breakpoint-md) {
  .add-to-cart-modal {
    &__buttons {
      display: flex;
      justify-content: space-between;
    }
    &__button {
      display: block;
      margin-bottom: 0;
      text-align: center;
      width: 48%;
    }
  }
}
</style>
